/*
 * ai-layout-route-cta.js
 *
 * GA4 measurement for the AI-layout-creator → drawer-builder routing CTA
 * (sections/ai-layout-route-cta.liquid). Fires a `route_to_builder` event to
 * window.dataLayer (GTM-M8JVKDS7) when a visitor takes the direct route into the
 * builder instead of completing the AI wizard. Lets us compare the direct-route
 * path against the wizard's own "Generate & open in builder" CTA and see whether
 * this band recovers the page's 0-conversion organic traffic.
 *
 * SAFETY:
 *   - PURELY ADDITIVE. One delegated click listener, guards window.dataLayer, every
 *     push wrapped in try/catch — analytics can never throw into the page.
 *   - No-ops if the CTA markup is absent.
 *   - Does not preventDefault; navigation to the builder is the normal <a> click.
 *
 * Event/param names are the single source of truth for the GTM trigger + GA4 params
 * — keep in sync with docs/analytics-events.md. The push() helper mirrors the
 * guarded emitter in assets/drawer-builder-analytics.js.
 *
 * DEBUG: append ?dbAnalytics=1 (or set window.DB_ANALYTICS_DEBUG = true) to log pushes.
 */
(function () {
  'use strict';

  var DEBUG = false;
  try {
    DEBUG = window.DB_ANALYTICS_DEBUG === true ||
      /[?&]dbAnalytics=1\b/.test(window.location.search || '');
  } catch (e) {}

  function assign(target, src) {
    if (src) for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
    return target;
  }
  function push(eventName, params) {
    try {
      var payload = assign({ event: eventName }, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      if (DEBUG && window.console) window.console.log('[ai-route-cta]', payload);
    } catch (e) {
      /* analytics must never break the page */
    }
  }

  var fired = false; // guard double-fire on rapid double-click

  function handleClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var link = t.closest('[data-ai-route-cta-link]');
    if (!link) return;
    if (fired) return;
    fired = true;
    push('route_to_builder', {
      source: 'ai_layout_creator',
      cta: 'route_band',
      destination: link.getAttribute('data-route-destination') || link.getAttribute('href') || ''
    });
  }

  function init() {
    if (!document.querySelector('[data-ai-route-cta]')) return;
    document.addEventListener('click', handleClick, true); // capture phase
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
